var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.123 62.5618C60.291 61.158 58.3091 59.9612 56.2134 58.9939L48.7217 55.5349C48.3511 56.5911 47.3823 58.9543 45.4678 61.3308C44.6587 62.3352 43.7759 63.2253 42.8276 64.0002H64L62.123 62.5618Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5322 61.3308C16.6177 58.9543 15.6489 56.5911 15.2783 55.5349L7.78662 58.9939C5.69092 59.9612 3.70898 61.158 1.87695 62.5618L0 64.0002H21.1724C20.2246 63.2253 19.3413 62.3357 18.5322 61.3308Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2061 52.2493V51.8225C40.9019 54.6003 36.6431 56.2761 32 56.2761C27.3569 56.2761 23.0981 54.6003 19.7944 51.8225V52.2493C19.7944 52.9788 19.3667 53.6472 18.7051 53.9524C18.7051 53.9524 21.5986 63.9998 32.0005 63.9998C42.4019 63.9998 45.2954 53.9524 45.2954 53.9524C44.6333 53.6472 44.2061 52.9788 44.2061 52.2493Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 52.5242C40.4092 52.5242 47.25 45.6804 47.25 37.2678V30.5139H16.75V37.2678C16.75 45.6804 23.5913 52.5242 32 52.5242Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7949 26.762H51.2051C52.2407 26.762 53.0801 25.9221 53.0801 24.8865C53.0801 23.8503 52.2407 23.0105 51.2051 23.0105H49.6299V21.071C49.6299 15.0251 46.5732 9.6814 41.9253 6.5022V14.4167C41.9253 15.4529 41.0859 16.2927 40.0503 16.2927C39.0151 16.2927 38.1753 15.4529 38.1753 14.4167V5.30933C38.1753 5.05981 38.2251 4.82153 38.314 4.60376C36.9111 4.06372 35.4229 3.698 33.875 3.53345V16.7175C33.875 17.7537 33.0352 18.5935 32 18.5935C30.9644 18.5935 30.125 17.7537 30.125 16.7175V3.53345C28.5771 3.69751 27.0894 4.06372 25.687 4.60327C25.7754 4.82153 25.8252 5.05933 25.8252 5.30933V14.4167C25.8252 15.4529 24.9858 16.2927 23.9502 16.2927C22.9146 16.2927 22.0752 15.4529 22.0752 14.4167V6.50122C17.4268 9.68042 14.3696 15.0251 14.3696 21.071V23.0105H12.7944C11.7593 23.0105 10.9194 23.8503 10.9194 24.8865C10.9194 25.9221 11.7593 26.762 12.7949 26.762Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9253 5.30957C41.9253 4.27344 41.0859 3.43359 40.0503 3.43359C39.2646 3.43359 38.5923 3.91797 38.314 4.60449C39.5962 5.09814 40.8071 5.7373 41.9253 6.50244V5.30957Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9507 3.43359C22.915 3.43359 22.0757 4.27344 22.0757 5.30957V6.50146C23.1938 5.73633 24.4048 5.09717 25.687 4.60352C25.4082 3.91797 24.7363 3.43359 23.9507 3.43359Z",
    fill: "#D29E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.875 3.53369V1.87598C33.875 0.839844 33.0356 0 32 0C30.9644 0 30.125 0.839844 30.125 1.87598V3.53369C30.7412 3.46777 31.3667 3.43359 32 3.43359C32.6333 3.43359 33.2588 3.46777 33.875 3.53369Z",
    fill: "#D29E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.79fdec7b62fb28f2af17803ec773776f.svg";
export { ForwardRef as ReactComponent };